import config from '../config/environment';
import supabase from '../config/supabase';
import {
  parseSensitiveStudentsDashboard,
  type SensitiveStudentsDashboard,
  type SensitiveStudentsDashboardQuery,
} from '../utils/sensitiveStudentsDashboard';
import { handleServiceError } from '../utils/errorHandler';

class SensitiveStudentsDashboardServiceClass {
  async getDashboard(query: SensitiveStudentsDashboardQuery): Promise<SensitiveStudentsDashboard> {
    const token = await this.getAccessToken();
    const url = this.buildUrl(query);

    const response = await fetch(url.toString(), {
      method: 'GET',
      headers: this.buildHeaders(token),
    });
    const body = await response.json().catch(() => ({})) as { error?: string };

    if (!response.ok) {
      handleServiceError(
        new Error(body.error || 'Erro ao carregar as alunas sensíveis'),
        'carregar as alunas sensíveis',
      );
    }

    const snapshot = parseSensitiveStudentsDashboard(body);
    if (!snapshot) {
      handleServiceError(
        new Error('Erro ao carregar as alunas sensíveis'),
        'carregar as alunas sensíveis',
      );
    }

    return snapshot;
  }

  private buildUrl(query: SensitiveStudentsDashboardQuery): URL {
    const url = new URL(`${config.supabaseFunctionsUrl}/sensitive-students-dashboard`);
    url.searchParams.set('page', String(query.page));
    url.searchParams.set('pageSize', String(query.pageSize));

    const search = query.searchName.trim();
    if (search) {
      url.searchParams.set('search', search);
    }

    if (query.status) {
      url.searchParams.set('status', query.status);
    }

    return url;
  }

  private async getAccessToken(): Promise<string | undefined> {
    const { data: sessionData } = await supabase.auth.getSession();
    return sessionData?.session?.access_token;
  }

  private buildHeaders(token: string | undefined): HeadersInit {
    return {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      apikey: config.supabaseAnonKey,
    };
  }
}

export const SensitiveStudentsDashboardService = new SensitiveStudentsDashboardServiceClass();
